import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// Mount the application
const domContainer = document.querySelector('#app-root');
if (!domContainer) {
  throw new Error('Missing #app-root element for main router');
}

// Prevent multiple mounts - check if already mounted
if (!domContainer.hasAttribute('data-react-mounted')) {
  domContainer.setAttribute('data-react-mounted', 'true');
  const root = createRoot(domContainer);
  root.render(<App />);
}
